module.exports = __webpack_public_path__ + "img/China_Mobile_logo.a5e604c2.png";